import { streetViewSecret } from '../config'

const crypto = require('crypto')
const url = require('url')

const removeWebSafe = safeEncodedString =>
  safeEncodedString.replace(/-/g, '+').replace(/_/g, '/')

const makeWebSafe = encodedString =>
  encodedString.replace(/\+/g, '-').replace(/\//g, '_')

const decodeBase64Hash = code =>
  Buffer.from ? Buffer.from(code, 'base64') : new Buffer(code, 'base64')

const encodeBase64Hash = (key, data) =>
  crypto
    .createHmac('sha1', key)
    .update(data)
    .digest('base64')

const signature = parsedUrl =>
  makeWebSafe(
    encodeBase64Hash(
      decodeBase64Hash(removeWebSafe(streetViewSecret)),
      parsedUrl.path
    )
  )

export const signUrl = path => {
  const parsedUrl = url.parse(path)
  return `${url.format(parsedUrl)}&signature=${signature(parsedUrl)}`
}



// WEBPACK FOOTER //
// ./src/utils/gsSignature.js